"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2891],{

/***/ 74964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Arrow; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



function Arrow(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512.002 512.002"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M388.425 241.951L151.609 5.79c-7.759-7.733-20.321-7.72-28.067.04-7.74 7.759-7.72 20.328.04 28.067l222.72 222.105-222.728 222.104c-7.759 7.74-7.779 20.301-.04 28.061a19.8 19.8 0 0014.057 5.835 19.79 19.79 0 0014.017-5.795l236.817-236.155c3.737-3.718 5.834-8.778 5.834-14.05s-2.103-10.326-5.834-14.051z",
            fill: props.color
        })
    }));
}


/***/ }),

/***/ 73174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ HeaderArrow; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var HeaderArrow = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || "7.561",
        height: props.height || "4.427",
        viewBox: "0 0 7.561 4.427",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            id: "Path_296380",
            fill: props.color || "#000",
            "data-name": "Path 296380",
            d: "M145.574,181.8l-3.166-3.166a.633.633,0,0,0-.893,0L138.35,181.8a.633.633,0,0,0,.893.893l2.716-2.716,2.722,2.716a.631.631,0,1,0,.893-.893Z",
            transform: "translate(-138.197 -178.446)"
        })
    });
};


/***/ }),

/***/ 52882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ HeaderHome; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var HeaderHome = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || "16.983",
        height: props.height || "16.984",
        viewBox: "0 0 16.983 16.984",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            id: "home",
            fill: props.color || "#000",
            d: "M17.026,7.387h0L10.1.458a1.563,1.563,0,0,0-2.211,0L.961,7.383.954,7.39a1.563,1.563,0,0,0,1.04,2.664l.048,0h.276v5.1a1.832,1.832,0,0,0,1.83,1.83H6.859a.5.5,0,0,0,.5-.5v-4a.836.836,0,0,1,.835-.835h1.6a.836.836,0,0,1,.835.835v4a.5.5,0,0,0,.5.5h2.711a1.832,1.832,0,0,0,1.83-1.83v-5.1h.256a1.564,1.564,0,0,0,1.107-2.669Zm-.7,1.507a.565.565,0,0,1-.4.167h-.754a.5.5,0,0,0-.5.5v5.6a.836.836,0,0,1-.835.835H11.62v-3.5a1.832,1.832,0,0,0-1.83-1.83h-1.6a1.832,1.832,0,0,0-1.83,1.83v3.5H4.148a.836.836,0,0,1-.835-.835v-5.6a.5.5,0,0,0-.5-.5H2.052a.568.568,0,0,1-.391-.97h0L8.589,1.162a.568.568,0,0,1,.8,0l6.926,6.926,0,0A.57.57,0,0,1,16.321,8.894Zm0,0",
            transform: "translate(-0.499)"
        })
    });
};


/***/ }),

/***/ 66974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ OrderIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



function OrderIcon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: props.size || 23.374,
        height: props.size || 23.374,
        viewBox: "0 0 23.374 23.374"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M0 0h23.374v23.374H0z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M22.707 10.209l-2.294-4a.649.649 0 00-.339-.287l-8.093-2.97a.651.651 0 00-.444 0L3.306 5.916a.65.65 0 00-.344.288l-2.294 4a.651.651 0 00.329.93l1.879.729v4.976a.651.651 0 00.43.612l8.17 2.942a.647.647 0 00.274.061h.009a.651.651 0 00.221-.038l8.231-2.964a.651.651 0 00.43-.612v-5.027l1.737-.674a.651.651 0 00.329-.93zM11.756 4.252l6.2 2.274-6.213 2.286-6.302-2.281zM3.819 7.327l6.976 2.525-1.75 3.012-6.872-2.665zm.362 5.046l4.912 1.909a.65.65 0 00.8-.28l1.207-2.078v6.956l-6.919-2.493zm15.163 4.014l-6.94 2.5v-6.85l1.077 1.952a.651.651 0 00.805.292l5.058-1.963zm-5-3.525l-1.657-3 6.873-2.528 1.644 2.87z",
                fill: props.secondaryColor || "#000"
            })
        ]
    }));
}


/***/ }),

/***/ 42891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Header1; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Headers/Header1/index.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  position: sticky;\n  width: 100%;\n  box-sizing: border-box;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 75px;\n  color: ",
        ";\n  background: ",
        ";\n  border-bottom: 1px solid transparent;\n  z-index: 10;\n  border-color: #efefef;\n  box-shadow: 0px 0px 5px 0px #00000040;\n\n  @media screen and (max-width: 766px) {\n    height: 60px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 1200px;\n  margin: 0 auto;\n  position: relative;\n  height: auto;\n  z-index: 10;\n\n  @media screen and (min-width: 767px) {\n    padding: 1rem 2rem;\n  }\n\n  @media screen and (max-width: 766px) {\n    padding: 0rem 1rem;\n  }\n\n  @media screen and (max-width: 400px) {\n    padding: 0rem 0.2rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  flex: 0 0 auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  @media screen and (min-width: 767px) {\n    display: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n\n  @media screen and (max-width: 766px) {\n    display: none;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-transform: uppercase;\n  cursor: pointer;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: 700;\n\n  @media screen and (min-width: 767px) {\n    font-size: 24px;\n    letter-spacing: 1.4px;\n    display: -webkit-box;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 14px;\n    letter-spacing: 1.4px;\n    display: ",
        ";\n  }\n\n  @media screen and (max-width: 350px) {\n    max-width: 150px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  border-radius: 50%;\n  width: 18px;\n  height: 18px;\n  display: flex;\n  flex: 0;\n  font-size: 12px;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  z-index: 2;\n  background: ",
        ";\n  color: ",
        ";\n  top: 0;\n  right: 0;\n  transform: translateX(50%) translateY(-50%);\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  height: 100vh;\n  left: 0;\n  top: 0;\n  width: 100%;\n  background: rgba(0, 0, 0, 0.62);\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  width: 100%;\n  height: fit-content;\n  position: fixed;\n  box-sizing: border-box;\n  top: 0;\n  left: 0;\n  background: ",
        ";\n  color: ",
        ";\n  padding-top: ",
        "px;\n  max-height: 100vh;\n  z-index: 5;\n  box-shadow: 0px 2px 5px -2px rgba(0, 0, 0, 0.5);\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-height: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  overflow-y: auto;\n  border-bottom: 0.5px solid rgba(255, 255, 255, 0.07);\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n  display: ",
        ";\n  width: 100%;\n  ",
        ";\n  padding: 14px 1rem;\n  justify-content: ",
        ";\n  align-items: ",
        ";\n\n  &:last-child {\n    border-bottom: none;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: 'flex';\n  flex-direction: column;\n  overflow-y: auto;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  padding: 1rem 2rem;\n  font-size: 15px;\n  letter-spacing: 0.3px;\n  cursor: pointer;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  & > div {\n    margin: 10px 0;\n  }\n\n  & > div:first-child {\n    margin-top: 0;\n  }\n\n  & > div:last-child {\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-size: 15px;\n  align-items: center;\n\n  & > p {\n    margin-left: 10px;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        ";\n  display: flex;\n  font-weight: 400;\n  align-items: center;\n  flex: 0 0 auto;\n  color: ",
        ";\n  position: relative;\n  cursor: pointer;\n\n  @media screen and (min-width: 767px) {\n    font-size: 18px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 15px;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  margin-left: 15px;\n  height: ",
        ";\n  width: ",
        ";\n  transform: ",
        ";\n  position: relative;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  position: absolute;\n  width: fit-content;\n  top: 39px;\n  left: -1rem;\n  background: ",
        ";\n  color: ",
        ";\n  box-shadow: 0px 2px 5px -2px rgba(0, 0, 0, 0.5);\n  box-sizing: border-box;\n  min-width: 100px;\n  overflow: hidden;\n  padding: 0.5rem 1rem;\n  max-height: 400px;\n  overflow-y: auto;\n  width: 250px;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: fit-content;\n  box-sizing: border-box;\n  width: 100%;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n  position: relative;\n  display: flex;\n  flex: 0;\n  cursor: pointer;\n  font-size: 14px;\n  width: 100%;\n  color: ",
        ";\n  padding: 10px 0px;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}

var HeaderComponent = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    displayName: "HeaderComponent",
    componentId: "sc-88485546-0"
})(_templateObject(), function(props) {
    return props.secondaryColor;
}, function(props) {
    return props.primaryColor;
});
var HeaderInner = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "HeaderInner",
    componentId: "sc-88485546-1"
})(_templateObject1());
var HeaderSections = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeaderSections",
    componentId: "sc-88485546-2"
})(_templateObject2());
var MobileHeader = (0,styled_components_browser_esm/* default */.ZP)(HeaderSections).withConfig({
    displayName: "MobileHeader",
    componentId: "sc-88485546-3"
})(_templateObject3());
var DesktopHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DesktopHeader",
    componentId: "sc-88485546-4"
})(_templateObject4());
var StoreName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "StoreName",
    componentId: "sc-88485546-5"
})(_templateObject5(), function(props) {
    return props.fontColor;
}, function(props) {
    return props.showStoreNameOnMobile ? "-webkit-box" : "none";
});
var CartTotalContainer = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "CartTotalContainer",
    componentId: "sc-88485546-6"
})(_templateObject6(), function(props) {
    return props.backgroundColor;
}, function(props) {
    return props.fontColor;
});
// Mobile Dropdown Styles
var MobileDropownContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MobileDropownContainer",
    componentId: "sc-88485546-7"
})(_templateObject7());
var MobileHeaderDrawer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MobileHeaderDrawer",
    componentId: "sc-88485546-8"
})(_templateObject8(), function(props) {
    return props.isOpen ? "flex" : "none";
}, function(props) {
    return props.primaryColor;
}, function(props) {
    return props.secondaryColor;
}, function(props) {
    return props.paddingTop || 0;
});
var HeaderDrawerInner = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "HeaderDrawerInner",
    componentId: "sc-88485546-9"
})(_templateObject9(), function(props) {
    return "calc(100vh - ".concat(props.heightLimiter, "px)");
});
var HeaderExpandable = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "HeaderExpandable",
    componentId: "sc-88485546-10"
})(_templateObject10());
var HeaderSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "HeaderSection",
    componentId: "sc-88485546-11"
})(_templateObject11(), function(props) {
    return props.display;
}, function(props) {
    return props.border && "border-bottom: 0.5px solid rgba(255,255,255,0.07);";
}, function(props) {
    return props.justifyContent || "flex-start";
}, function(props) {
    return props.alignItems || "flex-start";
});
var HeaderExpandedList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeaderExpandedList",
    componentId: "sc-88485546-12"
})(_templateObject12());
var HeaderExpandedListItem = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "HeaderExpandedListItem",
    componentId: "sc-88485546-13"
})(_templateObject13());
var HeaderSectionList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeaderSectionList",
    componentId: "sc-88485546-14"
})(_templateObject14());
var HeaderSectionListItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeaderSectionListItem",
    componentId: "sc-88485546-15"
})(_templateObject15());
var MenuItem = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "MenuItem",
    componentId: "sc-88485546-16"
})(_templateObject16(), function(props) {
    return props.margin || "0 0 0 20px";
}, function(props) {
    return props.secondaryColor;
});
var HeaderIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "HeaderIcon",
    componentId: "sc-88485546-17"
})(_templateObject17(), function(props) {
    return props.display || "inline-block";
}, function(props) {
    return "".concat(props.size, "px") || 0;
}, function(props) {
    return "".concat(props.size, "px") || 0;
}, function(props) {
    return props.iconPointer ? "rotateZ(270deg)" : "rotateZ(90deg)";
});
// Desktop Dropdown Styles
var DesktopHeaderDropdown = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "DesktopHeaderDropdown",
    componentId: "sc-88485546-18"
})(_templateObject18(), function(props) {
    return props.primaryColor || "#ffffff";
}, function(props) {
    return props.secondaryColor || "000000";
});
var DesktopDropdownItemList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DesktopDropdownItemList",
    componentId: "sc-88485546-19"
})(_templateObject19());
var DesktopDropdownItem = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "DesktopDropdownItem",
    componentId: "sc-88485546-20"
})(_templateObject20(), function(props) {
    return props.secondaryColor || "#000000";
});
var ShopingIconWrap = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "ShopingIconWrap",
    componentId: "sc-88485546-21"
})(_templateObject21());

// EXTERNAL MODULE: ./src/assets/svgExports/Arrow.js
var Arrow = __webpack_require__(74964);
// EXTERNAL MODULE: ./src/assets/svgExports/HeaderArrow.js
var HeaderArrow = __webpack_require__(73174);
// EXTERNAL MODULE: ./src/assets/svgExports/HeaderHome.js
var HeaderHome = __webpack_require__(52882);
// EXTERNAL MODULE: ./src/assets/svgExports/InfoIcon.js
var InfoIcon = __webpack_require__(67313);
// EXTERNAL MODULE: ./src/assets/svgExports/OrderIcon.js
var OrderIcon = __webpack_require__(66974);
// EXTERNAL MODULE: ./src/assets/svgExports/SearchIcon.js
var SearchIcon = __webpack_require__(50127);
// EXTERNAL MODULE: ./src/assets/svgExports/SupermarketIcon.js
var SupermarketIcon = __webpack_require__(81431);
// EXTERNAL MODULE: ./src/assets/svgExports/UserIconDark.js
var UserIconDark = __webpack_require__(52514);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(44541);
// EXTERNAL MODULE: ./src/utils/isPLPRequiredSystem.js
var isPLPRequiredSystem = __webpack_require__(86423);
// EXTERNAL MODULE: ./src/utils/commonToggleAuthModal.js
var commonToggleAuthModal = __webpack_require__(13605);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(86812);
// EXTERNAL MODULE: ./src/utils/getStoreType.js
var getStoreType = __webpack_require__(66871);
// EXTERNAL MODULE: ./src/utils/emoticonsStatus.js
var emoticonsStatus = __webpack_require__(18626);
// EXTERNAL MODULE: ./src/utils/orderDropdownList.js
var orderDropdownList = __webpack_require__(20503);
// EXTERNAL MODULE: ./src/utils/isClickOutside.js
var isClickOutside = __webpack_require__(53569);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
// EXTERNAL MODULE: ./src/utils/excuteLogout.js
var excuteLogout = __webpack_require__(85126);
// EXTERNAL MODULE: ./src/utils/getCustomCtaText.js
var getCustomCtaText = __webpack_require__(36623);
// EXTERNAL MODULE: ./src/hooks/useSaveHeaderHeight.js
var useSaveHeaderHeight = __webpack_require__(53395);
// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.js
var useFeatureLocks = __webpack_require__(27560);
// EXTERNAL MODULE: ./src/redux/actions/storeInfo.js
var storeInfo = __webpack_require__(17321);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(26706);
// EXTERNAL MODULE: ./src/components/MegaMenu/MegaMenuDesktopView.js + 1 modules
var MegaMenuDesktopView = __webpack_require__(46065);
// EXTERNAL MODULE: ./src/components/MegaMenu/MegaMenuMobileView.js
var MegaMenuMobileView = __webpack_require__(80574);
// EXTERNAL MODULE: ./src/utils/showMegaMenu.js
var showMegaMenu = __webpack_require__(36408);
// EXTERNAL MODULE: ./src/utils/logoAndNameHelpers.ts
var logoAndNameHelpers = __webpack_require__(73494);
// EXTERNAL MODULE: ./src/utils/handleRedirectToHomePage.js
var handleRedirectToHomePage = __webpack_require__(54051);
// EXTERNAL MODULE: ./src/utils/getActualOrDsStoreLogo.js
var getActualOrDsStoreLogo = __webpack_require__(68491);
// EXTERNAL MODULE: ./src/utils/getNavList.js
var getNavList = __webpack_require__(4956);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Headers/Header1/index.js





































var ReactHamburger = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 70440));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(70440)
            ];
        }
    }
});
var DesktopWhatsAppComp = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7091).then(__webpack_require__.bind(__webpack_require__, 57091));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57091)
            ];
        }
    }
});
var MobileWhatsAppComp = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2672).then(__webpack_require__.bind(__webpack_require__, 22672));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(22672)
            ];
        }
    }
});
var LogoutModal = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 21448));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21448)
            ];
        }
    }
});
var Header = function(props) {
    var clickExpandable = function clickExpandable() {
        setOpenCategory(!openCategory);
    };
    var toggleLogoutModal = function toggleLogoutModal() {
        setShowLogoutConfirmation(!showLogoutConfirmation);
    };
    var toggleShowDesktopDropdown = function toggleShowDesktopDropdown() {
        setShowDesktopDropdown(!showDesktopDropdown);
    };
    var onHandleOrdersClick = function onHandleOrdersClick(href) {
        if ((user === null || user === void 0 ? void 0 : user.isLogin) && href === routes.PATH.ORDERS && deviceWidth/* deviceWidth */.o > 766) {
            toggleShowDesktopDropdown();
        } else {
            router.push((0,routes.getRoute)(routes.PATH.ORDERS, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
        }
    };
    var toggleShowDesktopDropdown = function toggleShowDesktopDropdown() {
        setShowDesktopDropdown(!showDesktopDropdown);
    };
    var renderUserIconDesktop = function renderUserIconDesktop() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                deviceWidth/* deviceWidth */.o > 766 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "header-1 pointer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt1",
                                onClick: function() {
                                    return onHandleOrdersClick(routes.PATH.ORDERS);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserIconDark/* UserIconDark */.q, {
                                    color: "#000000",
                                    width: "24",
                                    height: "24"
                                })
                            })
                        }),
                        (user === null || user === void 0 ? void 0 : user.isLogin) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "header-1-arrow-img ml1 pointer " + (showDesktopDropdown ? "" : "rotate-180"),
                            onClick: toggleShowDesktopDropdown,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderArrow/* HeaderArrow */.i, {
                                color: "#000000",
                                width: "10",
                                height: "10"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: ref6,
                            className: "br2 absolute shadow-2 z-5 header-1-orderdropdown-container" + (isVisitorLoginVisible ? "" : "-nologin"),
                            children: showDesktopDropdown && ordersDropdownList.map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        item.id === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "header-1-orderdropdown-container-arrow"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "header-1-orderdropdown-container-item flex items-center z-5 " + (item.id === 3 ? "red " : "black ") + (item.id !== 1 && "pointer"),
                                            onClick: function(e) {
                                                return onHandleOrdersDropdown(item, e);
                                            },
                                            children: [
                                                item.id === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mr3 mt1",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserIconDark/* UserIconDark */.q, {
                                                        color: "black",
                                                        width: "33",
                                                        height: "33"
                                                    })
                                                }),
                                                item.name
                                            ]
                                        }, item.id)
                                    ]
                                });
                            })
                        })
                    ]
                }),
                showLogoutConfirmation && /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoutModal, {
                    toggleLogoutModal: toggleLogoutModal,
                    executeLogout: excuteLogout/* executeLogout */.q,
                    showLogoutConfirmation: showLogoutConfirmation
                })
            ]
        });
    };
    var renderUserIconMobile = function renderUserIconMobile() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header-1-mobile-login-navigation-container " + ((user === null || user === void 0 ? void 0 : user.isLogin) ? "red" : null),
                    onClick: toggleAuthModal,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UserIconDark/* UserIconDark */.q, {
                            color: "#000000",
                            width: "22",
                            height: "22"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mobile-translate-logout-text",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: (user === null || user === void 0 ? void 0 : user.isLogin) ? "Logout" : "Login"
                            })
                        })
                    ]
                }),
                showLogoutConfirmation && /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoutModal, {
                    toggleLogoutModal: toggleLogoutModal,
                    executeLogout: excuteLogout/* executeLogout */.q,
                    showLogoutConfirmation: showLogoutConfirmation
                })
            ]
        });
    };
    var ref, ref1, ref2, ref3, ref4, ref5;
    var _primaryColor = props.primaryColor, primaryColor = _primaryColor === void 0 ? "#000000" : _primaryColor, _secondaryColor = props.secondaryColor, secondaryColor = _secondaryColor === void 0 ? "#ffffff" : _secondaryColor;
    var ref6 = (0,react.useRef)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var ref7 = (0,react.useState)(0), height = ref7[0], setHeight = ref7[1];
    var ref8 = (0,react.useState)(false), isOpen = ref8[0], setOpen = ref8[1];
    var headerRef = (0,react.useRef)(null);
    var ref9 = (0,react.useState)(false), openCategory = ref9[0], setOpenCategory = ref9[1];
    var ref10 = (0,react.useState)(false), openMore = ref10[0], setOpenMore = ref10[1];
    var ref11 = (0,react.useState)([]), shopCategory = ref11[0], setShopCategory = ref11[1];
    var ref12 = (0,react.useState)(false), isHeaderRef = ref12[0], setHeaderRef = ref12[1];
    var ref13 = (0,react.useState)(false), scrolled = ref13[0], setScrolled = ref13[1];
    var ref14 = (0,react.useState)(false), showLogoutConfirmation = ref14[0], setShowLogoutConfirmation = ref14[1];
    var ref15 = (0,react.useState)(false), showDesktopDropdown = ref15[0], setShowDesktopDropdown = ref15[1];
    var ref16 = (0,es/* useSelector */.v9)(function(state) {
        return {
            user: state.userReducer,
            items: state.cartReducer.items,
            catalog: state.catalogReducer
        };
    }), user = ref16.user, items = ref16.items, _catalog = ref16.catalog, categories = _catalog.categories, productTags = _catalog.productTags;
    var storeData = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    });
    var store_info = storeData.store_info, theme = storeData.theme, services = storeData.services;
    var storeLogo = (0,getActualOrDsStoreLogo/* default */.Z)(storeData);
    var themeColor = theme === null || theme === void 0 ? void 0 : (ref = theme.colors) === null || ref === void 0 ? void 0 : ref.primary_color;
    var ordersDropdownList = (0,orderDropdownList/* default */.Z)();
    (0,useSaveHeaderHeight/* default */.Z)(headerRef);
    var visitorLoginFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().visitorLoginFeatureStatus;
    var isVisitorLoginVisible = visitorLoginFeatureStatus === null || visitorLoginFeatureStatus === void 0 ? void 0 : visitorLoginFeatureStatus.isVisible;
    (0,react.useEffect)(function() {
        setOpen(false);
        setShowLogoutConfirmation(false);
    }, [
        user === null || user === void 0 ? void 0 : user.isLogin
    ]);
    (0,react.useEffect)(function() {
        if (!isHeaderRef && headerRef.current) {
            setHeight(headerRef.current.offsetHeight);
            setHeaderRef(true);
        }
        if (categories && categories.length > 0) {
            var categoryTemp = categories.filter(function(el) {
                return el.id !== 0;
            });
            setShopCategory((0,_to_consumable_array/* default */.Z)(productTags).concat((0,_to_consumable_array/* default */.Z)(categoryTemp)));
        }
    }, [
        headerRef,
        categories
    ]);
    var handleScroll = function() {
        if (headerRef.current) {
            setScrolled(headerRef.current.getBoundingClientRect().top <= 1);
        }
    };
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", function() {
            return handleScroll();
        }, {
            passive: true
        });
        return function() {
            window.removeEventListener("scroll", function() {
                return handleScroll();
            }, {
                passive: true
            });
        };
    }, []);
    (0,react.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        ref6
    ]);
    var toggleAuthModal = function() {
        if ((0,commonToggleAuthModal/* commonToggleAuthModal */.D)({
            userLogin: user === null || user === void 0 ? void 0 : user.isLogin,
            storeInfoDomain: store_info === null || store_info === void 0 ? void 0 : store_info.domain
        })) toggleLogoutModal();
    };
    var onHandleOrdersDropdown = function(item) {
        var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        switch(item.action){
            case constants/* ORDERS_DROPDOWN_LIST.MY_ORDERS */.Bm.MY_ORDERS:
                {
                    toggleShowDesktopDropdown();
                    router.push((0,routes.getRoute)(routes.PATH.ORDERS, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
                    break;
                }
            case constants/* ORDERS_DROPDOWN_LIST.LOGOUT */.Bm.LOGOUT:
                {
                    toggleLogoutModal();
                    break;
                }
            case constants/* ORDERS_DROPDOWN_LIST.DEFAULT_PHONE */.Bm.DEFAULT_PHONE:
                {
                    break;
                }
            default:
                {
                    break;
                }
        }
    };
    var handleCartClick = function() {
        if ((0,getStoreType/* getStoreType */.K)({
            services: services
        }) === constants/* STORE_CUSTOMIZATION.B2B */.DO.B2B) {
            dispatch((0,storeInfo/* toggleRfqFormModal */.H4)());
            return;
        }
        router.push((0,routes.getRoute)(routes.PATH.CART, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
    };
    var handleClickOutside = function(e) {
        var callback = function() {
            return setShowDesktopDropdown(false);
        };
        (0,isClickOutside/* commonOutsideClick */.C)({
            event: e,
            pathNo: 0,
            ref: ref6,
            callback: callback
        });
    };
    /**
   * Render cartIcon
   * @return {JSX}
   */ var _renderCartIcon = function() {
        return items.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "pl2 pb2 pt3 pr3 br3",
            style: {
                backgroundColor: themeColor
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShopingIconWrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SupermarketIcon/* SupermarketIcon */.N, {
                        color: secondaryColor,
                        width: "20",
                        height: "18"
                    }),
                    items && items.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartTotalContainer, {
                        backgroundColor: secondaryColor,
                        fontColor: themeColor,
                        children: items.length
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
            className: "pl2 pb2 pt2 pr3",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopingIconWrap, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SupermarketIcon/* SupermarketIcon */.N, {
                    color: themeColor,
                    width: "20",
                    height: "18"
                })
            })
        });
    };
    return theme ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderComponent, {
        position: props.position,
        primaryColor: secondaryColor,
        secondaryColor: themeColor,
        ref: headerRef,
        scrolled: scrolled,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderInner, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderSections, {
                        style: {
                            flex: "1 1 100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileHeader, {
                                style: {
                                    flex: "1 1 100%",
                                    paddingRight: 20,
                                    paddingLeft: 10
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactHamburger, {
                                            open: isOpen,
                                            setOpen: setOpen,
                                            theme: themeColor
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreName, {
                                        style: {
                                            paddingLeft: 10
                                        },
                                        showStoreNameOnMobile: props.showStoreNameOnMobile,
                                        fontColor: themeColor,
                                        onClick: function() {
                                            router.push((0,routes.getRoute)(routes.PATH.PRODUCT, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
                                        },
                                        children: store_info === null || store_info === void 0 ? void 0 : store_info.name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DesktopHeader, {
                                style: {
                                    flex: "1 1 100%",
                                    paddingRight: 20,
                                    maxWidth: "45vw"
                                },
                                children: [
                                    storeLogo && (0,logoAndNameHelpers/* getVisibilityForHeader */.g)(theme === null || theme === void 0 ? void 0 : theme.store_logo_status) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "header-logo-image mr3 pointer",
                                        src: storeLogo,
                                        alt: "store logo",
                                        onClick: function() {
                                            (0,handleRedirectToHomePage/* redirectToHomePage */.A)(routes.PATH.PRODUCT, store_info === null || store_info === void 0 ? void 0 : store_info.domain);
                                            setOpenCategory(false);
                                        }
                                    }),
                                    (0,logoAndNameHelpers/* getVisibilityForHeader */.g)(theme === null || theme === void 0 ? void 0 : theme.store_name_status) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreName, {
                                        onClick: function() {
                                            (0,handleRedirectToHomePage/* redirectToHomePage */.A)(routes.PATH.PRODUCT, store_info === null || store_info === void 0 ? void 0 : store_info.domain);
                                            setOpenCategory(false);
                                        },
                                        fontColor: themeColor,
                                        children: store_info === null || store_info === void 0 ? void 0 : store_info.name
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderSections, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DesktopHeader, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                                        onClick: function() {
                                            router.push((0,routes.getRoute)(routes.PATH.PRODUCT, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
                                            setOpenCategory(false);
                                        },
                                        children: "Home"
                                    }),
                                    (theme === null || theme === void 0 ? void 0 : (ref1 = theme.cta_config) === null || ref1 === void 0 ? void 0 : ref1.header_cta) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem, {
                                        style: {
                                            display: "flex",
                                            alignItems: "center",
                                            position: "relative"
                                        },
                                        onClick: clickExpandable,
                                        children: [
                                            theme === null || theme === void 0 ? void 0 : (ref2 = theme.cta_config) === null || ref2 === void 0 ? void 0 : ref2.header_cta,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderIcon, {
                                                display: "flex",
                                                size: 12,
                                                iconPointer: openCategory,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow/* Arrow */.E, {
                                                    color: themeColor
                                                })
                                            }),
                                            !(0,showMegaMenu/* showMegaMenu */.G)() && openCategory && /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopHeaderDropdown, {
                                                primaryColor: secondaryColor,
                                                secondaryColor: themeColor,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopDropdownItemList, {
                                                    children: shopCategory.map(function(cat) {
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(DesktopDropdownItem, {
                                                            onClick: function() {
                                                                setOpenCategory(false);
                                                                if ((0,isPLPRequiredSystem/* isPLPRequiredSystem */.q)(theme === null || theme === void 0 ? void 0 : theme.theme_class)) {
                                                                    router.push((0,routes.getRoute)("".concat(routes.PATH.SHOP, "?cid=").concat(cat.id), store_info === null || store_info === void 0 ? void 0 : store_info.domain), undefined, {
                                                                        shallow: true
                                                                    });
                                                                } else {
                                                                    router.push((0,routes.getRoute)("".concat(routes.PATH.PRODUCT, "?cid=").concat(cat.id), store_info === null || store_info === void 0 ? void 0 : store_info.domain), undefined, {
                                                                        shallow: true
                                                                    });
                                                                }
                                                            },
                                                            children: (0,emoticonsStatus/* removeEmoticons */._)(cat === null || cat === void 0 ? void 0 : cat.name)
                                                        }, "".concat(cat === null || cat === void 0 ? void 0 : cat.name, "-").concat(cat === null || cat === void 0 ? void 0 : cat.id));
                                                    })
                                                })
                                            })
                                        ]
                                    }) : null,
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                                        onClick: function() {
                                            router.push((0,routes.getRoute)(routes.PATH.ABOUT_US, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
                                        },
                                        children: "About Us"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopWhatsAppComp, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                                margin: "0 0 0 25px",
                                onClick: function() {
                                    router.push((0,routes.getRoute)(routes.PATH.SEARCH, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchIcon/* SearchIcon */.W, {
                                    color: themeColor,
                                    size: "18",
                                    className: "".concat((props === null || props === void 0 ? void 0 : props.hideCart) ? "!tw-mr-2.5" : "")
                                })
                            }),
                            !(props === null || props === void 0 ? void 0 : props.hideCart) && (services === null || services === void 0 ? void 0 : services.store_flag) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                                margin: "0 10px 0 15px",
                                onClick: handleCartClick,
                                children: _renderCartIcon()
                            }),
                            deviceWidth/* deviceWidth */.o > 766 && renderUserIconDesktop()
                        ]
                    })
                ]
            }),
            (0,showMegaMenu/* showMegaMenu */.G)() && deviceWidth/* deviceWidth */.o > 766 && /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuDesktopView/* default */.Z, {
                open: openCategory,
                onClose: function() {
                    return setOpenCategory(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileHeader, {
                children: isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileDropownContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileHeaderDrawer, {
                        // ref={headerDropdownRef}
                        paddingTop: height,
                        isOpen: isOpen,
                        primaryColor: secondaryColor,
                        secondaryColor: "#000000",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderDrawerInner, {
                            heightLimiter: height,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSection, {
                                    border: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem, {
                                        margin: "0px",
                                        onClick: function() {
                                            setOpen(false);
                                            router.push((0,routes.getRoute)(routes.PATH.PRODUCT, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                style: {
                                                    marginRight: 24,
                                                    marginLeft: 2
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderHome/* HeaderHome */.Q, {
                                                    color: primaryColor
                                                })
                                            }),
                                            "Home"
                                        ]
                                    })
                                }),
                                (theme === null || theme === void 0 ? void 0 : (ref3 = theme.cta_config) === null || ref3 === void 0 ? void 0 : ref3.header_cta) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderExpandable, {
                                    heightLimiter: height,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderSection, {
                                            display: "flex",
                                            border: false,
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            onClick: clickExpandable,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem, {
                                                    margin: "0px",
                                                    children: [
                                                        (theme === null || theme === void 0 ? void 0 : (ref4 = theme.cta_config) === null || ref4 === void 0 ? void 0 : ref4.header_cta) === "Shop" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            style: {
                                                                marginRight: 24
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SupermarketIcon/* SupermarketIcon */.N, {
                                                                color: primaryColor,
                                                                width: 20,
                                                                height: 18
                                                            })
                                                        }),
                                                        theme === null || theme === void 0 ? void 0 : (ref5 = theme.cta_config) === null || ref5 === void 0 ? void 0 : ref5.header_cta
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderIcon, {
                                                    size: 16,
                                                    iconPointer: openCategory,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow/* Arrow */.E, {
                                                        color: "#000000"
                                                    })
                                                })
                                            ]
                                        }),
                                        (0,showMegaMenu/* showMegaMenu */.G)() ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                paddingLeft: "50px"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuMobileView/* default */.Z, {
                                                open: openCategory,
                                                onClose: function() {
                                                    return setOpen(false);
                                                }
                                            })
                                        }) : openCategory && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderExpandedList, {
                                            children: shopCategory.map(function(item) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(HeaderExpandedListItem, {
                                                    onClick: function() {
                                                        setOpen(false);
                                                        if ((0,isPLPRequiredSystem/* isPLPRequiredSystem */.q)(theme === null || theme === void 0 ? void 0 : theme.theme_class)) {
                                                            router.push((0,routes.getRoute)("".concat(routes.PATH.SHOP, "?cid=").concat(item.id), store_info === null || store_info === void 0 ? void 0 : store_info.domain), undefined, {
                                                                shallow: true
                                                            });
                                                        } else {
                                                            router.push((0,routes.getRoute)("".concat(routes.PATH.PRODUCT, "?cid=").concat(item.id), store_info === null || store_info === void 0 ? void 0 : store_info.domain), undefined, {
                                                                shallow: true
                                                            });
                                                        }
                                                    },
                                                    children: (0,emoticonsStatus/* removeEmoticons */._)(item.name)
                                                }, "".concat(item.name, "-").concat(item.id));
                                            })
                                        })
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSection, {
                                    border: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderSectionList, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderSectionListItem, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderIcon/* OrderIcon */.c, {
                                                        secondaryColor: "#000000"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                                                        secondaryColor: "#000000",
                                                        onClick: function() {
                                                            router.push((0,routes.getRoute)(routes.PATH.ORDERS, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
                                                        },
                                                        children: (0,getCustomCtaText/* default */.Z)("my_orders_cta")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileWhatsAppComp, {
                                                secondaryColor: "#000000"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderSectionListItem, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIcon/* InfoIcon */.s, {
                                                        size: 24,
                                                        secondaryColor: "#000000"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                                                        secondaryColor: "#000000",
                                                        onClick: function() {
                                                            router.push((0,routes.getRoute)(routes.PATH.ABOUT_US, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
                                                        },
                                                        children: "About Us"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                (0,getNavList/* showMyAccount */.p6)() ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderExpandable, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderSection, {
                                            display: "flex",
                                            border: false,
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            onClick: function() {
                                                return setOpenMore(!openMore);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                                                    margin: "0px",
                                                    children: "More"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderIcon, {
                                                    size: 16,
                                                    iconPointer: openMore,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow/* Arrow */.E, {
                                                        color: "#000000"
                                                    })
                                                })
                                            ]
                                        }),
                                        openMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderExpandedList, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderExpandedListItem, {
                                                onClick: function() {
                                                    return router.push((0,routes.getRoute)(routes.PATH.MY_ACCOUNT, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
                                                },
                                                children: "My Account"
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSection, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSectionList, {
                                        children: deviceWidth/* deviceWidth */.o < 767 && isVisitorLoginVisible && renderUserIconMobile()
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var Header1 = (Header);


/***/ }),

/***/ 46065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MegaMenu_MegaMenuDesktopView; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/MegaMenu/megaMenu.module.scss
var megaMenu_module = __webpack_require__(98224);
var megaMenu_module_default = /*#__PURE__*/__webpack_require__.n(megaMenu_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/MegaMenu/svgIcons.js
var svgIcons = __webpack_require__(20941);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(44541);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
;// CONCATENATED MODULE: ./src/components/MegaMenu/RenderCategory.js







var RenderCategory = function(props) {
    var splitObjectsIntoGroups = function splitObjectsIntoGroups(objects, batchSize) {
        var result = [];
        for(var i = 0; i < objects.length; i += batchSize){
            var batch = objects.slice(i, i + batchSize);
            result.push(batch);
        }
        return result;
    };
    var categories = props.categories, onClose = props.onClose, collectionId = props.collectionId;
    var ref = (0,react.useState)([]), currCategories = ref[0], setCurrCategories = ref[1];
    var ref1 = (0,react.useState)({
        more: false,
        less: false
    }), showMoreLess = ref1[0], setShowMoreLess = ref1[1];
    var storeData = (0,es/* useSelector */.v9)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    (0,react.useEffect)(function() {
        if (categories.length < 36) {
            setCurrCategories(categories);
        } else if (categories.length >= 36) {
            setShowMoreLess({
                more: true,
                less: false
            });
            setCurrCategories(categories.slice(0, 36));
        }
    }, [
        categories
    ]);
    (0,react.useEffect)(function() {
        if (showMoreLess.more) {
            setCurrCategories(categories.slice(0, 36));
        } else {
            setCurrCategories(categories);
        }
    }, [
        showMoreLess
    ]);
    var totalCategories = currCategories === null || currCategories === void 0 ? void 0 : currCategories.length;
    var maxCols = Math.min(6, Math.ceil(totalCategories / 6));
    var maxRows = Math.max(6, Math.ceil(totalCategories / maxCols));
    var handleCategoryClick = function(category) {
        var ref;
        if (category.isMoreLess) return;
        router_default().push((0,routes.getRoute)("".concat(routes.PATH.collectionCategories(collectionId), "?cid=").concat(category.id), storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain), undefined, {
            shallow: true,
            scroll: true
        });
        onClose && onClose();
    };
    var displayMoreLess = function(type) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex",
            style: {
                gap: "2px",
                alignItems: "center",
                cursor: "pointer"
            },
            onClick: handleMoreLessClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: {
                        color: "#000"
                    },
                    children: type
                }),
                showMoreLess.more ? /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* MoreCarat */.MK, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* LessCarat */.gO, {})
            ]
        });
    };
    var handleMoreLessClick = function() {
        if (showMoreLess.more) {
            setShowMoreLess({
                more: false,
                less: true
            });
        } else {
            setShowMoreLess({
                more: true,
                less: false
            });
        }
    };
    var splittedCategories = splitObjectsIntoGroups(currCategories, maxRows);
    if (currCategories.length >= 36) {
        var ref2;
        (ref2 = splittedCategories[maxCols - 1]) === null || ref2 === void 0 ? void 0 : ref2.push({
            isMoreLess: true,
            type: showMoreLess.more ? "More" : "Less"
        });
    }
    var categoriesGrid = [];
    for(var row = 0; row < maxRows; row++){
        categoriesGrid.push([]);
        for(var col = 0; col < maxCols; col++){
            var index = row + col * maxRows;
            if (index < totalCategories) {
                categoriesGrid[row].push(currCategories[index]);
            } else {
                categoriesGrid[row].push(null); // Add a placeholder for empty cells
            }
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (megaMenu_module_default()).categoriesWrapper,
        style: {
            width: "700px",
            gap: "24px"
        },
        children: splittedCategories.map(function(col, colIndex) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (megaMenu_module_default()).categoryColumn,
                children: col.map(function(category, rowIndex) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (megaMenu_module_default()).categoryItem,
                        onClick: function() {
                            return handleCategoryClick(category);
                        },
                        children: category.isMoreLess && categories.length > 36 ? displayMoreLess(category.type) : category.name
                    }, colIndex);
                })
            }, colIndex);
        })
    });
};
/* harmony default export */ var MegaMenu_RenderCategory = (RenderCategory);

// EXTERNAL MODULE: ./src/utils/routeToCollectionPage.js
var routeToCollectionPage = __webpack_require__(85618);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(26706);
;// CONCATENATED MODULE: ./src/components/MegaMenu/MegaMenuDesktopView.js








var MEGA_MENU_BACKDROP = "MEGA_MENU_BACKDROP";
var MegaMenuDesktopView = function(param) {
    var open = param.open, onClose = param.onClose;
    var collections = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            collections: state.catalogReducer.collections
        };
    }).collections;
    var ref = (0,react.useState)(null), highlightedCollectionId = ref[0], setHighlightedCollectionId = ref[1];
    (0,react.useEffect)(function() {
        if (open) {
            document.body.classList.add("tw-overflow-y-hidden");
        } else {
            document.body.classList.remove("tw-overflow-y-hidden");
        }
        return function() {
            document.body.classList.remove("tw-overflow-y-hidden");
        };
    }, [
        open
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (highlightedCollectionId && collections.length > 2 && (highlightedCollectionId === ((ref = collections[collections.length - 2]) === null || ref === void 0 ? void 0 : ref.id) || highlightedCollectionId === ((ref1 = collections[0]) === null || ref1 === void 0 ? void 0 : ref1.id))) {
            var currentCollection = document.getElementById("panel-collection-id-".concat(highlightedCollectionId));
            if (currentCollection) {
                var dialogRect = currentCollection.parentElement.getBoundingClientRect();
                var elementRect = currentCollection.getBoundingClientRect();
                // Calculate the offset from the top of the dialog to the top of the element
                var offset = elementRect.top - dialogRect.top - 34;
                // Scroll the dialog by the calculated offset
                currentCollection.parentElement.scrollTo({
                    top: currentCollection.parentElement.scrollTop + offset,
                    behavior: "smooth"
                });
            }
        }
    }, [
        highlightedCollectionId
    ]);
    (0,react.useEffect)(function() {
        var handleIntersection = function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    var collectionId = parseInt(entry.target.dataset.collectionId);
                    setHighlightedCollectionId(collectionId);
                }
            });
        };
        var observer = new IntersectionObserver(handleIntersection, {
            root: document.getElementById("collection-in-view"),
            rootMargin: "0px 0px -350px 0px",
            threshold: 0.25
        });
        var collectionContentNodes = document.querySelectorAll("[data-collection-id]");
        collectionContentNodes.forEach(function(node) {
            return observer.observe(node);
        });
        return function() {
            return observer.disconnect();
        };
    }, [
        open
    ]);
    var handleLeftPanelCollectionClick = function(e, collectionId) {
        e.stopPropagation();
        var collectionContent = document.getElementById("collection-".concat(collectionId));
        if (collectionContent) {
            var dialogRect = collectionContent.parentElement.getBoundingClientRect();
            var elementRect = collectionContent.getBoundingClientRect();
            // Calculate the offset from the top of the dialog to the top of the element
            var offset = elementRect.top - dialogRect.top - 16;
            // Scroll the dialog by the calculated offset
            collectionContent.parentElement.scrollTo({
                top: collectionContent.parentElement.scrollTop + offset,
                behavior: "smooth"
            });
        }
    };
    var renderCollectionNameList = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (megaMenu_module_default()).collectionListWrapper,
            children: collections.map(function(collection) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()((megaMenu_module_default()).collectionNameMenu, collection.id === highlightedCollectionId ? (megaMenu_module_default()).highlighted : ""),
                    id: "panel-collection-id-".concat(collection.id),
                    onClick: function(e) {
                        return handleLeftPanelCollectionClick(e, collection.id);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (megaMenu_module_default()).collectionName,
                            children: collection.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (megaMenu_module_default()).leftCaratIcon,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* LeftCaratIcon */.vT, {})
                        })
                    ]
                }, collection.id);
            })
        });
    };
    var renderCollectionCategories = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (megaMenu_module_default()).collectionContentWrapper,
            id: "collection-in-view",
            children: collections.map(function(collection) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (megaMenu_module_default()).collectionContent,
                    id: "collection-".concat(collection.id),
                    "data-collection-id": collection.id,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (megaMenu_module_default()).collectionImage,
                            children: collection.image_url ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: collection.image_url
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* CollectionWithNoImage */.p3, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (megaMenu_module_default()).categoriesDisplay,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (megaMenu_module_default()).collectionName,
                                    onClick: function() {
                                        (0,routeToCollectionPage/* routeToCollectionPage */.L)(collection);
                                        onClose();
                                    },
                                    children: collection.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu_RenderCategory, {
                                    collectionId: collection.id,
                                    categories: collection.categories,
                                    onClose: onClose
                                })
                            ]
                        })
                    ]
                }, collection.id);
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((megaMenu_module_default()).desktopView, open ? (megaMenu_module_default()).open : ""),
        id: MEGA_MENU_BACKDROP,
        onClick: function(e) {
            var ref;
            if (((ref = e.target) === null || ref === void 0 ? void 0 : ref.id) === MEGA_MENU_BACKDROP) {
                e.stopPropagation();
                onClose === null || onClose === void 0 ? void 0 : onClose();
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-bg-white",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.04)",
                        width: "100%",
                        position: "relative",
                        top: "0",
                        height: "8px"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        width: "100%",
                        height: "500px",
                        background: "#fff",
                        display: "flex"
                    },
                    children: [
                        renderCollectionNameList(),
                        renderCollectionCategories()
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var MegaMenu_MegaMenuDesktopView = (MegaMenuDesktopView);


/***/ }),

/***/ 20949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _checkIfThemePreview__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15483);
/* harmony import */ var _checkRenderEnv__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6337);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13886);
/* harmony import */ var _getUrlParams__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5492);




var checkIfShowDummyProduts = function(storeData) {
    var isPreview = (0,_checkIfThemePreview__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    var isPremium = !!storeData.premium;
    var items_available = (!_checkRenderEnv__WEBPACK_IMPORTED_MODULE_1__/* .IS_SERVER */ .W6 && (0,_getUrlParams__WEBPACK_IMPORTED_MODULE_3__/* .getUrlParams */ .D)([
        _constants__WEBPACK_IMPORTED_MODULE_2__/* .PREVIEW_PARAMS.ITEMS_AVAILABLE */ .I.ITEMS_AVAILABLE
    ])).items_available;
    var isItemsAvailable = +items_available;
    return isPreview && (!isPremium || !isItemsAvailable);
};
/* harmony default export */ __webpack_exports__["Z"] = (checkIfShowDummyProduts);


/***/ }),

/***/ 13605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ commonToggleAuthModal; }
/* harmony export */ });
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44541);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);


/**
 * common function to initiate auth toggle
 * @param {*} param0
 * @return {boolean} return
 */ var commonToggleAuthModal = function(param) {
    var userLogin = param.userLogin, storeInfoDomain = param.storeInfoDomain;
    if (userLogin) {
        return true;
    } else {
        next_router__WEBPACK_IMPORTED_MODULE_1___default().push((0,_routes__WEBPACK_IMPORTED_MODULE_0__.getRoute)(_routes__WEBPACK_IMPORTED_MODULE_0__.PATH.ORDERS, storeInfoDomain));
    }
    return false;
};


/***/ }),

/***/ 68491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _checkIfShowDummyProducts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20949);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13886);


/**
 * function to get store logo in case of dummy or actual data
 * @param storeInfo
 * @returns
 */ var getActualOrDsStoreLogo = function(storeInfo) {
    var ref;
    var showDummyData = (0,_checkIfShowDummyProducts__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(storeInfo);
    return (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.logo_image) || (showDummyData ? _constants__WEBPACK_IMPORTED_MODULE_1__/* .DS_LOGO_IMAGE_URL */ .pP : null);
};
/* harmony default export */ __webpack_exports__["Z"] = (getActualOrDsStoreLogo);


/***/ }),

/***/ 4956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p6": function() { return /* binding */ showMyAccount; }
/* harmony export */ });
/* unused harmony export isUserLoggedIn */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29815);
/* harmony import */ var _checkClientDeviceType__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13508);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80344);
/* harmony import */ var _checkRenderEnv__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6337);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44541);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13886);






var isUserLoggedIn = function() {
    var ref;
    return !!((ref = _redux_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getState */ .Z.getState().userReducer) === null || ref === void 0 ? void 0 : ref.isLogin);
};
var showMyAccount = function() {
    return !_checkRenderEnv__WEBPACK_IMPORTED_MODULE_2__/* .IS_SERVER */ .W6 && _checkClientDeviceType__WEBPACK_IMPORTED_MODULE_0__/* .IS_MOBILE */ .q$ && _checkRenderEnv__WEBPACK_IMPORTED_MODULE_2__/* .IS_WEBVIEW */ .x5 && isUserLoggedIn();
};
var myAccountNavData = {
    page_name: "My Account",
    slug_url: _routes__WEBPACK_IMPORTED_MODULE_3__.PATH.MY_ACCOUNT,
    page_type: "my-account"
};
var getNavList = function(navigationItems) {
    var visibleItemsLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _constants__WEBPACK_IMPORTED_MODULE_4__/* .MAX_VISIBLE_NAV_LINKS */ .Ow, showCategories = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var subNavObj = {
        page_type: "subNavList",
        subNavs: [],
        is_editable: false,
        page_id: "616d2bd6152384798123d775",
        page_name: showCategories ? "Categories" : "More",
        slug_url: showCategories ? "more" : "subNavList"
    };
    var showMyAccountSection = showMyAccount();
    if ((navigationItems === null || navigationItems === void 0 ? void 0 : navigationItems.length) > 0) {
        var tempNavList = [];
        if (showCategories) {
            tempNavList = navigationItems.filter(function(nav) {
                return nav.page_type !== "shop";
            });
        } else {
            tempNavList = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(navigationItems);
        }
        if ((navigationItems === null || navigationItems === void 0 ? void 0 : navigationItems.length) > visibleItemsLength) {
            var extractedNavList = tempNavList.splice(visibleItemsLength, tempNavList.length);
            subNavObj.subNavs = extractedNavList;
            if (showMyAccountSection) {
                subNavObj.subNavs.push(myAccountNavData);
            }
            var newNavList = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(tempNavList).concat([
                subNavObj
            ]);
            return newNavList;
        } else {
            if (showMyAccountSection) {
                subNavObj.subNavs.push(myAccountNavData);
                tempNavList.push(subNavObj);
            }
            return tempNavList;
        }
    }
    return [];
};
/* harmony default export */ __webpack_exports__["ZP"] = (getNavList);


/***/ }),

/***/ 54051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ redirectToHomePage; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44541);


var redirectToHomePage = function(path, domain) {
    next_router__WEBPACK_IMPORTED_MODULE_0___default().push((0,_routes__WEBPACK_IMPORTED_MODULE_1__.getRoute)(path, domain));
};


/***/ }),

/***/ 53569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ commonOutsideClick; },
/* harmony export */   "W": function() { return /* binding */ isOutsideClick; }
/* harmony export */ });
var isOutsideClick = function(parentRef, target) {
    var ref;
    if ((ref = parentRef.current) === null || ref === void 0 ? void 0 : ref.contains(target)) return true;
    return false;
};
var commonOutsideClick = function(param) {
    var event = param.event, _pathNo = param.pathNo, pathNo = _pathNo === void 0 ? 0 : _pathNo, ref = param.ref, callback = param.callback;
    var path = event.path || event.composedPath && event.composedPath();
    if (!isOutsideClick(ref, path[pathNo])) {
        callback && callback();
    }
};


/***/ }),

/***/ 73494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ getVisibilityForFooter; },
/* harmony export */   "g": function() { return /* binding */ getVisibilityForHeader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29815);
// the status defines the visibility of logo or name with respect to header and footer

var STATUS_DISABLED = 0;
var STATUS_SHOW_ON_HEADER = 1;
var STATUS_SHOW_ON_FOOTER = 2;
var STATUS_SHOW_ON_HEADER_FOOTER = 3;
// const STATUS_DONT_SHOW_ON_HEADER_FOOTER = 4;
var COMMON_STATUS_SHOW = [
    STATUS_DISABLED,
    STATUS_SHOW_ON_HEADER_FOOTER
];
function getVisibilityForHeader(status) {
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(COMMON_STATUS_SHOW).concat([
        STATUS_SHOW_ON_HEADER
    ]).includes(status);
}
function getVisibilityForFooter(status) {
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(COMMON_STATUS_SHOW).concat([
        STATUS_SHOW_ON_FOOTER
    ]).includes(status);
}


/***/ })

}]);